import { Outlet, useLocation, Navigate } from "react-router-dom"

const PrivateRoute = (props) => {
  const user = sessionStorage.getItem("user")
  const location = useLocation()

  return user ? (
    <Outlet context={props} />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  )
}
export default PrivateRoute
